import {TextArea} from '@/components/atoms'
import {withJsonFormsControlProps} from '@jsonforms/react'
import React, {useEffect} from 'react'

const TextAreaComponent = props => {
  const {handleChange, label, data, path, error, schema, uischema, required, enabled, visible} = props

  useEffect(() => {
    if (!enabled && data) {
      handleChange(path, '')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled])

  const updateValue = (newVal, isValid) => {
    const value = schema.type === 'string' && newVal ? newVal.trim() : newVal
    handleChange(path, value)
    handleChange(path + 'Valid', isValid)
  }

  return visible ? (
    <TextArea
      value={data || ''}
      label={uischema.showLabel === false ? '' : label}
      updateValue={updateValue}
      error={error}
      schema={schema}
      uiSchema={uischema}
      required={required}
      disabled={!enabled}
    />
  ) : null
}

const TextAreaControl = withJsonFormsControlProps(TextAreaComponent)
export default TextAreaControl